<template>
  <div class="base-report report-payment-node">
    <div class="filter">
      <el-form inline>
        <el-select v-model="searchForm.method" size="mini" >
          <el-option
            v-for="item in methods"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="searchForm.from_date"
          type="date"
          size="mini"
          placeholder="開始日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.to_date"
          type="date"
          size="mini"
          placeholder="終了日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-button size="mini" type="primary" @click="fetchData" :disabled="isLoading">表示</el-button>
        <div style="float: right; padding-right: 20px;">
          <el-button v-show="$store.getters.isPC && screenData.length>0" size="mini" type="success" icon="el-icon-download" @click="exportCSV">ダウンロード</el-button>
        </div>
      </el-form>
    </div>
    <div class="table_data" v-loading="isLoading">
      <template v-if="screenData.length>0">
        <el-table
          :data="screenData"
          border
          stripe
          show-summary
          height="100%"
          :summary-method="getSummaries">

          <template v-for="(header, index) in tableSetting">
            <template v-if="header.prop === 'date' && currentMethod === methodType.daily">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template slot-scope="scope">
                  <div class="date">
                    {{ scope.row.date|date }}
                    <span class="w" :class="weekdayClass(scope.row)">{{ printWeekday(scope.row) }}</span>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template v-else-if="!Array.isArray(header)">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                align="right"
                :sortable=header.sortable
                :min-width=header.width>
                <template v-if="Array.isArray(tableSetting[index + 1])">
                  <template v-for="(subheader, subindex) in tableSetting[index + 1]">
                    <el-table-column
                    :key="subheader.prop + subindex"
                    :label=subheader.label
                    :prop=subheader.prop
                    :min-width=subheader.width
                    align="right"
                    :sortable=subheader.sortable
                    :formatter="formatter">
                    </el-table-column>
                  </template>
                </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </template>
      <div v-else v-show="noData">
        データがありません。<br>
        条件を変えて再度「表示」ボタンを押してください。
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import addFigure from '@/misc/addFigure.js'
import downloadCSV from '@/misc/downloadCSV.js'

export default {
  name: 'ReportPaymentAnalyze',
  data () {
    const methodType = {
      daily: 1,
      monthly: 2,
    }
    return {
      isLoading: false,
      noData: false,
      methodType: {...methodType},
      methods: [{value: methodType.daily, label: '日毎'}, {value: methodType.monthly, label: '月毎'}],
      staticSetting: [
        {label: '年月日', prop: 'date', fixed: true, sortable: true, width: '130px'},
        {label: '売上合計', prop: 'sales', sortable: true, width: '130px'},
        {label: '売上（税抜）', prop: 'salesExcludeTax', sortable: true, width: '130px'},
        {label: '税合計', prop: 'tax', sortable: true, width: '130px'},
      ],
      tableSetting: [],
      searchForm: {
        method: methodType.daily,
        from_date: null,
        to_date: null,
      },
      items: [],
      currentMethod: methodType.daily,
      screenData: [],
      orgData: [],
      totalData: [],
      form: {},
      csv_filename: '支払管理表.csv',
    }
  },
  computed: {
    ...mapGetters('holiday', ['holidays']),
  },
  filters: {
    date (value) {
      return moment(value).format('YYYY/MM/DD')
    },
  },
  methods: {
    ...mapActions('holiday', ['getHolidays']),
    fetchData () {
      this.isLoading = true
      this.noData = false
      this.items = []
      this.tableSetting = []
      this.tableSetting.push(...this.staticSetting)
      this.tableSetting[0].label = this.getDateStr()
      this.screenData = []
      this.totalData = []
      this.orgData = []
      this.currentMethod = this.searchForm.method

      this.$request.reports.paymentAnalyzes(this.searchForm.from_date, this.searchForm.to_date, this.searchForm.method).then(res => {
        this.items = res.body

        if (this.items.headers) {
          var paymentHeader = this.items.headers.payments
          this.addHeader(paymentHeader)
        }

        for (let record of this.items.records) {
          this.orgData.push(record)
        }
        this.updateScreenData()
      }, err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
        this.noData = !this.screenData.length
      })
    },

    addHeader (headers) {
      for (let header of headers) {
        let code = `${header.code}_${header.name}`
        this.tableSetting.push({
          label: header.name,
          code: code,
        })
        this.tableSetting.push([
          {label: '件数', prop: code + '_count', sortable: true, width: '80px'},
          {label: '金額', prop: code + '_price', sortable: true, width: '120px'},
        ])
      }
    },
    updateScreenData () {
      this.screenData = []
      let tmp = this.orgData
      for (let data of tmp) {
        let record = data.data
        let payments = record.payments
        for (let payment of payments) {
          const code = `${payment.code}_${payment.name}`
          let countKey = code + '_count'
          let priceKey = code + '_price'
          record[priceKey] = payment.amount
          record[countKey] = payment.count
        }
        this.screenData.push(record)
      }
    },
    getSummaries ({columns, data}) {
      columns.forEach((column, index) => {
        if (index === 0) {
          this.totalData[index] = '合計'
          return true
        }
        let reducer = function (a, b) {
          let valb = parseFloat(b[columns[index].property]) || 0
          return a + valb
        }
        const values = data.reduce(reducer, 0)
        this.totalData[index] = this.formatData(columns[index].property, values)
      })

      return this.totalData
    },
    exportCSV () {
      let header = []
      let keyList = []
      for (let tableHeader of this.tableSetting) {
        if (Array.isArray(tableHeader)) {
          let preHeader = header.pop()
          for (let subHeader of tableHeader) {
            if (subHeader.prop) {
              keyList.push(subHeader.prop)
            }
            header.push(`${preHeader}-${subHeader.label}`)
          }
        } else {
          if (tableHeader.prop) {
            keyList.push(tableHeader.prop)
          }
          header.push(tableHeader.label)
        }
      }
      let data = []
      for (let record of this.screenData) {
        let tmp = []
        for (let key of keyList) {
          tmp.push(this.formatData(key, record[key]))
        }
        data.push(tmp)
      }

      downloadCSV(this.csv_filename, header, data, this.totalData)
    },
    date (value) {
      let result = '-'
      switch (this.currentMethod) {
        case this.methodType.daily:
          let date = moment(value).format('YYYY/MM/DD')
          let day = moment(value).locale('ja').format('ddd')
          result = date + '(' + day + ')'
          break
        case this.methodType.monthly:
          result = moment(value).format('YYYY年MM月')
          break
      }
      return result
    },
    getDateStr () {
      switch (this.searchForm.method) {
        case this.methodType.daily:
          return '年月日'
        case this.methodType.monthly:
          return '年月'
      }
    },
    formatter (row, column) {
      let key = column.property
      return this.formatData(key, row[key])
    },
    formatData (key, value) {
      switch (key) {
        case 'date':
          return this.date(value)
        default:
          value = !isNaN(value) ? value : 0
          return addFigure(parseInt(value))
      }
    },
    isHoliday (date, before = false) {
      const k = before ? moment(date).add(1, 'days').format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD')
      if (this.holidays[k]) {
        return true
      }
      return false
    },
    printWeekday (item) {
      if (this.isHoliday(item.date)) {
        return '祝'
      }
      return moment(item.date).locale('ja').format('ddd')
    },
    weekdayClass (item) {
      if (this.isHoliday(item.date)) {
        return 'hol'
      }
      let ret = moment(item.date).locale('en').format('ddd').toLowerCase()
      if (ret !== 'sun' && this.isHoliday(item.date, true)) {
        return 'bho'
      }
      return ret
    },
  },
  mounted () {
    this.getHolidays()
    this.searchForm.from_date = moment().date(1).format('YYYY-MM-DD')
    this.searchForm.to_date = moment().format('YYYY-MM-DD')
//    this.fetchData()
  },
}
</script>

<style lang="sass">
@import "static/sass/report/common.sass"
</style>

<style scoped>
div.date {
  text-align: center;
  height: 40px;
  line-height: 40px;
}

div.date span.w {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  background-color: #ABC;
  border-radius: 50%;
  line-height: 16px;
  font-size: 0.7em;
  text-align: center;
  color: #FFF;
  vertical-align: 2px;
}

div.date span.w.sat,
div.date span.w.bho {
  background-color: #3CD;
}

div.date span.w.sun,
div.date span.w.hol {
  background-color: #E34;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/PaymentAnalyze.vue